import { apiAuth, apiResponseType } from "./index";

export const getEndorsements = (
  page = 1,
  params?: {
    status?: string;
    sale_id?: string;
    seller_id?: string[];
    lottery_id?: string[];
    contest_id?: string[];
    client_name?: string;
    client_document?: string;
    start_date?: string;
    end_date?: string;
    order_by?: "created_at" | "status" | "client_name";
    order_direction?: "asc" | "desc";
    per_page?: number;
  }
) => {
  const query = new URLSearchParams({ page: String(page) });

  Object.entries(params ?? {}).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((item) => query.append(`${key}[]`, item));
    } else if (value !== undefined && value !== "") {
      query.append(key, String(value));
    }
  });

  return apiAuth.get(`endorsements?${query.toString()}`) as apiResponseType;
};

// Nome/CPF do cadastro do cliente da venda e se já existe solicitação ativa
export const getEndorsementPrefill = (saleId: number) =>
  apiAuth.get(`endorsements/prefill/${saleId}`) as apiResponseType;

// Status da última solicitação por venda (sale_id => status), para esconder o botão na lista de vendas
export const getEndorsementSalesStatus = (saleIds: number[]) => {
  const query = new URLSearchParams();
  saleIds.forEach((id) => query.append("sale_ids[]", String(id)));

  return apiAuth.get(`endorsements/sales-status?${query.toString()}`) as apiResponseType;
};

/** LOT-68: a solicitação é criada já com o primeiro anexo (obrigatório). */
export const createEndorsement = (data: {
  sale_id: number;
  client_name: string;
  client_document: string;
  description?: string;
  file: File;
}) => {
  const formData = new FormData();
  formData.append("sale_id", String(data.sale_id));
  formData.append("client_name", data.client_name);
  formData.append("client_document", data.client_document);
  if (data.description) formData.append("description", data.description);
  formData.append("file", data.file);

  return apiAuth.post("endorsements", formData) as apiResponseType;
};

export const approveEndorsement = (uuid: string) =>
  apiAuth.post(`endorsements/${uuid}/approve`) as apiResponseType;

export const rejectEndorsement = (uuid: string, reviewer_notes: string) =>
  apiAuth.post(`endorsements/${uuid}/reject`, { reviewer_notes }) as apiResponseType;

export const getEndorsementFiles = (uuid: string) =>
  apiAuth.get(`endorsements/${uuid}/files`) as apiResponseType;

export const uploadEndorsementFile = (uuid: string, file: File) => {
  const formData = new FormData();
  formData.append("file", file);

  return apiAuth.post(`endorsements/${uuid}/files`, formData) as apiResponseType;
};

export const deleteEndorsementFile = (uuid: string, fileId: number) =>
  apiAuth.delete(`endorsements/${uuid}/files/${fileId}`) as apiResponseType;
